import { render } from "./ChartUploadDocumentReviewModal.vue?vue&type=template&id=a8cefe6a&scoped=true&ts=true"
import script from "./ChartUploadDocumentReviewModal.vue?vue&type=script&lang=ts"
export * from "./ChartUploadDocumentReviewModal.vue?vue&type=script&lang=ts"

import "./ChartUploadDocumentReviewModal.vue?vue&type=style&index=0&id=a8cefe6a&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8cefe6a"]])

export default __exports__